<template>
  <v-card class="food-card" flat :class="{ 'mobile-card': device.isMobile }">
    <div v-if="isDisabledCard" class="food-card-disabled"></div>

    <v-row no-gutters>
      <v-img
        @click="openPreview"
        :src="mealImage"
        height="100%"
        aspect-ratio="1"
        :max-width="device.isMobile ? '80px' : '120px'"
        cover
      />

      <!-- Center and Right: Content with padding -->
      <v-col class="px-2">
        <!-- Meal Name -->
        <v-row no-gutters class="fill-height flex-column py-1" justify="space-between">
          <div>
            <p
              class="mb-0"
              style="line-height: 1.1"
              :class="
                device.isMobile
                  ? 'body-1 font-weight-medium'
                  : 'subtitle-1 font-weight-bold'
              "
            >
              {{ meal.name }}
            </p>
          </div>

          <!-- Only Button - no quantity controls -->
          <div>
            <v-row
              no-gutters
              :justify="showPrice && meal.price ? 'space-between' : 'end'"
              align="center"
            >
              <div
                v-if="showPrice && meal.price"
                class="text-body-2 font-weight-medium mt-1"
              >
                <span class="primary--text">{{ meal.price }}</span> KM
              </div>
              <primary-button
                v-if="!isDisabledCard"
                :small="device.isMobile"
                @click="onCompanyBtnClick"
                :height="device.isMobile ? '32px' : '36px'"
              >
                {{ workerBtnText }}
              </primary-button>
            </v-row>
          </div>
        </v-row>
      </v-col>
    </v-row>

    <company-menu-worker-food-order-dialog
      v-model="previewDialog"
      :daily-menu="dailyMenu"
      :shift="shift"
      :meal="meal"
    />
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import conf from "@/config";
import CompanyMenuWorkerFoodOrderDialog from "@/components/companyMenu/dialogs/CompanyMenuWorkerFoodOrderDialog.vue";
import hasMenuOrdering from "@/mixins/hasMenuOrdering";

export default {
  name: "CompanyMenuFoodCard",
  mixins: [hasMenuOrdering],
  props: {
    meal: { type: Object, required: true },
    dailyMenu: { type: Object, required: true },
    shift: { type: String, required: true },
    order: {
      type: Object,
      required: true,
    },
    disabled: { type: Boolean, default: false },
  },
  components: {
    CompanyMenuWorkerFoodOrderDialog,
  },
  data() {
    return {
      conf,
      previewDialog: false,
    };
  },
  computed: {
    ...mapState("companyMenu", ["dayTo"]),
    user() {
      return this.$store.state.user.user;
    },
    restaurant() {
      return this.$store.state.restaurant
        ? this.$store.state.restaurant
        : this.$store.state.company.restaurant;
    },
    showPrice() {
      const company = this.$store.state.company;
      if (!company.settings) return false;
      const settings = JSON.parse(company.settings);
      return !!settings?.show_price;
    },
    isDisabledWorker() {
      return (
        (this.dailyMenu.test !== this.meal.id + `_${this.shift.num}-smena` &&
          !!this.dailyMenu.test) ||
        (!this.restaurant.settings.rok_dana && this.meal.order?.quantity_payed > 0) ||
        (this.dayTo > this.dailyMenu.date && !this.params.checkTime)
      );
    },
    isDisabledCard() {
      return (
        this.disabled || (this.order.id && !this.meal.order) || this.isDisabledWorker
      );
    },
    imageStyle() {
      return this.device.isMobile
        ? "border-radius: 12px 12px 0px 0px"
        : "border-radius: 6px";
    },
    workerBtnText() {
      if (!this.restaurant.settings.rok_dana && this.meal.order?.quantity_payed > 0) {
        return this.$t("ordered_meal");
      }
      if (this.dayTo > this.dailyMenu.date && !this.params.checkTime) {
        return this.$t("ordered_meal");
      }
      if (this.meal.order) {
        return this.$t("cancel");
      }
      return this.$t("order");
    },
  },
  methods: {
    openPreview() {
      this.previewDialog = true;
    },
  },
};
</script>

<style scoped>
.food-card {
  border: 1px solid #e1e1e1;
  margin: 12px 0;
  position: relative;
  overflow: hidden;
}

.food-card-disabled {
  position: absolute;
  background: #ffffff;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 2;
  opacity: 0.5;
}

/* Mobile styles */
.mobile-card {
  margin: 8px 0;
}
</style>
